import React, {Component, useContext} from 'react';
import ReactDOM from 'react-dom';
import { Layout, SixtyFourtyLayout } from '../../../layouts';
import Welcome from '../../../layouts/welcome';
import Row from '../../../components/row';
import { ButtonCancel, ButtonModify, ButtonProceed, ButtonRemove, ButtonReturn, ButtonSave, ButtonView } from '../../../components/buttons';
import Container from '../../../layouts/containers/container';

import TabBar from '../components/tab-bar';
import companiesApi from '../../../lib/companies/companies-api';
import List from '../../../components/list';
import ContainerIndex from '../../../layouts/containers/container-index';
import Divider from '../../../components/divider/divider';
import Grid from '../../../components/grid';
import InputsText from '../../../components/inputs/inputs-text';
import InputsDropdown from '../../../components/inputs/inputs-dropdown';
import PopupContext from '../../../context/context-popup';
import PopupsDeleteMember from '../popups/popups-delete-member';
import PopupsInviteUser from '../popups/popups-invite-user';
import ContentDropdown from '../../../components/content-dropdown';
import PopupsRemoveInvite from '../popups/popups-remove-invite';
import LabelContainer from '../../../components/label-container';
import { stringToFriendlyDatetime } from '../../../lib/helpers/datetime-helpers';
import adminApi from '../../../lib/admin/admin-api';
import usersApi from '../../../lib/users/users-api';
import { SmallPill } from '../../../components/pills';
import MediaHelper from '../../../lib/helpers/media';
import meApi from '../../../lib/users/me-api';
import { toast } from 'react-toastify';
import PopupsNewPassword from '../popups/popups-new-password';
import PlainCard from '../../../components/cards/card-plain';
import ActivityItemNew from '../../../components/activity/activity-item-new';
import activityParams from '../../../lib/users/activity';
import RenderThisIf from '../../../components/renderIf';
import EmptyState from '../../../components/states/empty';
import Scrollable from '../../../components/scrollable';
import ProfileImage from '../../../components/profile-image';

const el = document.getElementById('account-index');

class UserActivity extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activity: null
        }
    }

    componentDidMount() {
        companiesApi.userActions(window?.user?.company_id, window.user?.id).then(({ data }) => {
            this.setState({ activity: data });
        })
    }

    render() {
        return (
            <Container>
                <Container.Header>
                    <Container.Text fontSize="30px" color="#FF6933">Activity</Container.Text>
                </Container.Header>

                <Container.Content style={{
                    height: this.state.activity?.length === 0 ? '400px' : ''
                }}>
                    <RenderThisIf
                        renderIf={this.state.activity?.length === 0 || this.state.activity === null}
                        render={
                            <EmptyState
                                loading={this.state.activity === null}
                                title="Activity"
                                description="There has been no recent activity"
                                titleColor="black"
                                descriptionColor="black"
                                style={{ height: '100%' }}
                                showImage={false}
                            />
                        }
                    >
                        <Scrollable maxItems={6} itemHeight={111.73} spacing={20}>
                            <List gap="20px">
                                { this.state.activity?.map((activity) => {
                                    const params = activityParams(activity);

                                    const [ type, action ] = activity?.type;

                                    return <ActivityItemNew
                                        icon={false}
                                        className="dashboard-activity-item"
                                        subtitle={params?.message}
                                        title={params?.body}
                                        body={params?.created_at}
                                    />
                                }) }
                            </List>
                        </Scrollable>
                    </RenderThisIf>
                </Container.Content>
            </Container>
        )
    }
}

const Security = () => {
    const { setPopup } = useContext(PopupContext);

    const openNewPassword = () => setPopup(<PopupsNewPassword/>);

    return <ButtonProceed onClick={openNewPassword}>Change Password</ButtonProceed>

    // return (
    //     <Container>
    //         <Container.Header>
    //             <Container.Text fontSize="30px" color="#FF6933">Security</Container.Text>
    //         </Container.Header>

    //         <Container.Content>
    //             <ButtonProceed onClick={openNewPassword}>Change Password</ButtonProceed>
    //         </Container.Content>
    //     </Container>
    // )
}

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: null,
            errors: {},
            loading: true,
        }
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        companiesApi.user(window.user?.company_id, window.user?.id).then(({ data }) => {
            this.setState({
                loading: false,
                user: {
                    ...data,
                    ...(data.user_profile || {})
                },
                roles: data?.roles
            });
        })
    }

    setRoles(role_ids) {
        this.setState({ role_ids })
    }

    save() {
       meApi.update(this.state.user, (errors) => {
        this.setState({ errors })
       }).then(() => {
        toast.success('Sucessfully updated', {
            position: toast.POSITION.BOTTOM_CENTER
        })

        this.setState({ errors: {} })
        this.fetch();
       })
    }

    onChange(e) {
        const { name, value } = e.target;
        const user = { ...this.state.user }

        user[name] = value;

        this.setState({ user })
    }

    render() {
        return (
            <Layout
                theme="light"
                loading={this.state.loading}
                topLeft={
                    <Welcome
                        title={<Container.Text fontSize="18px" color="#FF6933">Manage</Container.Text>}
                        subtitle="My Account"
                    />
                }
                topRight={
                    <Row gap="20px" wrap>
                        <Security/>
                        <ButtonSave onClick={this.save.bind(this)}>Save</ButtonSave>
                        <ButtonReturn>Cancel</ButtonReturn>
                    </Row>
                }
            >
                <List gap="40px">
                    <TabBar active={0}/>

                    <SixtyFourtyLayout
                        main={
                            <List gap="40px" divider={<Divider/>}>
                                <Container>
                                    <Container.Header>
                                        <Container.Text fontSize="30px" color="#FF6933">About Me</Container.Text>
                                    </Container.Header>

                                    <Container.Content>
                                        <List gap="40px">
                                            <LabelContainer label="Profile Picture">
                                                <ProfileImage
                                                    user={this.state.user}
                                                    onChange={this.fetch.bind(this)}
                                                />
                                            </LabelContainer>

                                            <Grid
                                                gap="40px"
                                                columnsDesktop={2}
                                                columnsTablet={2}
                                                columnsMobile={1}
                                            >
                                                <InputsText
                                                    label="First Name"
                                                    name="first_name"
                                                    value={this.state?.user?.first_name}
                                                    onChange={this.onChange.bind(this)}
                                                    errors={this.state.erorrs?.first_name}
                                                />

                                                <InputsText
                                                    label="Last Name"
                                                    name="last_name"
                                                    value={this.state?.user?.last_name}
                                                    onChange={this.onChange.bind(this)}
                                                    errors={this.state.erorrs?.last_name}
                                                />

                                                <InputsText
                                                    label="Email Address"
                                                    name="email"
                                                    value={this.state?.user?.email}
                                                    onChange={this.onChange.bind(this)}
                                                    errors={this.state.erorrs?.email}
                                                />
                                            </Grid>
                                        </List>
                                    </Container.Content>
                                </Container>

                                <Container>
                                    <Container.Header>
                                        <Container.Text fontSize="30px" color="#FF6933">My Roles</Container.Text>
                                    </Container.Header>

                                    <Container.Content>
                                        <ContainerIndex>
                                            <ContainerIndex.Content>
                                                { this.state?.roles?.map((role, index) => {
                                                    return <PlainCard key={index} type="plain-card--green plain-card--fit">
                                                        <Row gap="20px" justifyContent="space-between">
                                                            <List gap="5px">
                                                                <Container.Text fontSize="20px" color="white">{ role?.name }</Container.Text>
                                                                <Container.Text fontSize="16px" color="rgb(236 236 236)">{ role?.description }</Container.Text>
                                                            </List>
                                                        </Row>
                                                    </PlainCard>
                                                }) }
                                            </ContainerIndex.Content>
                                        </ContainerIndex>
                                    </Container.Content>
                                </Container>
                            </List>
                        }
                        sectionOne={{
                            name: '',
                            component: <UserActivity/>
                        }}
                    />
                </List>
            </Layout>
        )
    }
}

if (el) {
    ReactDOM.render(
       <App/>
    , el);
}
